import { AgmCoreModule } from '@agm/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Injector, NgModule, SystemJsNgModuleLoader } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { ToastrModule } from 'ngx-toastr';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AppRouterService, OrvServicesModule, OrvUiBaseLibModule } from 'orv-ui-base-lib';

import { environment } from '../environments/environment';
import { AuthModule } from './@core/auth/auth.module';
import { CoreComponentsModule } from './@core/core-components/core-components.module';
import { CoreModule } from './@core/core.module';
import { ServiceLocator } from './@core/data/locator.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FullComponent } from './layouts/full/full.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { SpinnerComponent } from './shared/spinner.component';


export function HttpLoaderFactory(http: HttpClient) {
	if (environment.hasOwnProperty('commercial') && environment.commercial === true) {
		return new TranslateHttpLoader(http, undefined, '-commercial.json');
	}
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [
		AppComponent,
		SpinnerComponent,
		FullComponent,
		NavigationComponent,
		BreadcrumbComponent,
		SidebarComponent,
		SIDEBAR_TOGGLE_DIRECTIVES
	],
	imports: [
		OrvUiBaseLibModule,
		OrvServicesModule,
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		CoreComponentsModule,
		FormsModule,
		HttpClientModule,
		AppRoutingModule,
		AuthModule,
		CoreModule.forRoot(),
		ToastrModule.forRoot(),
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyA9YsRv2pFxoUzcP8jaBtAOIbDyjZl-q6I',
			libraries: ['drawing', 'places', 'geometry', 'visualization']
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			},
		}),
		UiSwitchModule.forRoot({
			size: 'small',
			color: 'rgba(78, 78, 78)',
			switchColor: '#DD4842',
			defaultBgColor: '#E1E0E0',
			defaultBoColor: '#000',
			checkedLabel: '',
			uncheckedLabel: ''
		}),
		LoggerModule.forRoot({
			level: !environment.production ? NgxLoggerLevel.LOG : NgxLoggerLevel.OFF,
			// serverLogLevel
			serverLogLevel: NgxLoggerLevel.OFF
		}),
		DeviceDetectorModule.forRoot(),
	],
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy
		},
		TranslateService,
		AppRouterService,
		SystemJsNgModuleLoader
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private injector: Injector) {
		// Create global Service Injector.
		ServiceLocator.injector = this.injector;
	}
}

